export const formatScheduledHour = (hour: number): string => `${String(hour).padStart(2, '0')}:00`
